import React, { useContext, useReducer, useState } from 'react';
import axios from 'axios';
import reducer from '../reducers/clientReducer';
import { SAVE_CLIENTS, EDIT_CLIENTS, SEARCH_CLIENTS, REFRESH_CLIENTS } from '../actions';
import { baseUrl, loansUrl } from '../utils/constants';

const initialState = {
  currentClient: {},
  clientBankingDetails: {},
  clientAffordability: {},
  clientRefId: -1
};

const initialClient = {
  firstName: '',
  surname: '',
  idNumber: '',
  dateOfBirth: '',
  gender: 'F',
  cellNumber: '',
  emailAddress: '',
  maritalStatus: 1,
  employerRefId: '',
  paypointRefId: '',
  age: 0,
  height: 0,
  weight: 0,
  bloodGroup: '',
  prevOtherMebNo: '',
  prevMascaMebNo: '',
  medSociety: '',
  coverPeriod: 0,
  occupation_ID: 0,
  industry_ID: 0,
  dependants: 0,
  sex_ID: 0,
  title_id: '',
  group_id: '',
  reasonForTerm: '',
  physical_Town_ID: 0,
  physical_Suburb_ID: 0,
  postal_Town_ID: 0,
  postal_Suburb_ID: 0,
  nextOfKin_Suburb_ID: 0,
  nextOfKinTown_ID: 0,
  nextOfKinFName: '',
  nextOfKinSName: '',
  nextOfKinAdd1: '',
  nextOfKinHomePhone: '',
  nextOfKinWorkPhone: '',
  branch_ID: 0,
  bank_ID: 0,
  principalSchemeID: 1,
  memberType_ID: 1,
  relationship_ID: '',
  country_ID: 41,
  memberStatus: 1,
  acc_No: '',
  acc_Name: '',
  membershipStartDate: '',
  // retirementDate: '',
  home_Phone: '',
  postal_Phone: '',
  postal_Add1: '',
  physical_Add1: '',
  accName: '',
  copayment: 0,
  sortCode: '',
  work_Phone: '',
  cash_paying: false,
  dpt: '',
  stn: '',
  station: '',
  dist: ''
};

const newMembers = {
  ecNumber: '',
  firstName: '',
  surname: '',
  idNumber: '',
  dateOfBirth: '',
  gender: 'F',
  cellNumber: '',
  emailAddress: '',
  dpt: '',
  stn: '',
  station: '',
  district: '',
  reference: '',
  reason: '',
  deductionType: 'New',
  startDate: '',
  endDate: '',
  monthlyRate: 0,
  totalDue: 0,
  repaymentPeriod: 0,
  payslipFilename: '',
  idFilename: '',
  password: '',
  confirmPassword: '',
  loginType: 0,
  loginIdentifier: '',
  alternateLoginIdentifier: null,
  partnerRefId: 1
};

const initialDep = {
  cif_number: 0,
  firstName: '',
  surname: '',
  cellNumber: null,
  emailAddress: null,
  maritalStatus: 1,
  sex_ID: 0,
  title_id: '',
  memberType_ID: 1,
  relationship_ID: '',
  memberStatus: 1,
  suffix: '',
  benefitType: 1
};

const initialDoc = {
  OwnerIdentifier: '',
  UploadDate: '',
  claimRefId: 0,
  DocumentType: 0,
  DocumentPath: '',
  OriginalFileName: '',
  DocumentFilename: '',
  TransportMethod: 2,
  IsValidated: false,
  UploadedByUserRefId: 0,
  MimeType: 'application/octet-stream',
  State: 0,
  clientRefId: 0
};

const initialLoanApp = {
  loanList: [],
  clientName: null,
  idNumber: null,
  clientRefId: 0,
  recordTotal: 0,
  applicationRefId: 0,
  hasBridgeJob: true,
  bridgeJobRefId: 0,
  loanApplicationStatus: 1,
  loanApplicationDescription: '',
  allocatedTo: 'Un-Allocated',
  lastActionDate: '',
  createdDate: '',
  originationSourcesName: 'Internal',
  replyStatus: 0,
  replyMessage: '',
  uniqueIdentifier: null,
  transactionRef: 0
};

export const ClientContext = React.createContext();

export const ClientProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [clientRefId, setClientRefId] = useState(-1);
  const [parentRefId, setParentRefId] = useState(-1);
  const [regRefId, setRegRefId] = useState(-1);
  const [newClient, setNewClient] = useState(newMembers);
  const [customerIdentifier, setCustomerIdentifier] = useState('');
  const [currentClient, setCurrentClient] = useState(initialClient);
  const [currDependant, setDependant] = useState(initialDep);
  const [dependantList, setDependantList] = useState([]);
  const [loadingClient, setLoadingClient] = useState(true);
  const [clientDocList, setClientDocList] = useState([]);
  const [currentDocument, setCurrentDoc] = useState(initialDoc);
  const [limitsList, setLimitList] = useState([]);
  const [limitsListPharmacy, setLimitListPharmacy] = useState([]);
  const [loanPortfolio, setPortfolio] = useState(initialLoanApp);

  const searchClient = (id, value) => {
    dispatch({ type: SEARCH_CLIENTS, payload: { id, value } });
  };

  const refreshClientValues = (clientRefId) => {
    console.log('client cleared all', clientRefId);
    if (clientRefId > 0) {
      console.log('clientre at get here', clientRefId);
      getClientsByAfc(clientRefId);
      updateGlBalances(clientRefId);
    } else {
      setClientRefId(-1);
      setCurrentClient(initialClient);
      getClientsByAfc(clientRefId);
      console.log('just cleared all');
    }
  };

  const clearContext = () => {
    setClientRefId(-1);
    setCurrentClient(initialClient);
  };

  const clearDependant = () => {
    setDependant(initialDep);
    setDependantList([]);
  };

  const getClientByRefId = async (refId) => {
    console.log('regRefId refId', refId);
    await fetch(`${baseUrl}/api/client/GetNewClientByRefId?refId=${refId}`)
      .then((res) => res.json())
      .then(
        (result) => {
          setNewClient(result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getClientsByAfc = async (clientRefId) => {
    // const afcNo = 139478;
    console.log('afc at this point', clientRefId);
    fetch(`${baseUrl}/api/client/GetClientByAfcCifNo?afcNumber=${clientRefId}`)
      .then((res) => res.json())
      .then(
        (result) => {
          setCurrentClient(result.result);
          // setDependant(result.result);
          setCustomerIdentifier(result.result.cif_number);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getLimits = (medFundNo) => {
    fetch(`${baseUrl}/api/product/GetLimitSummary?medFundNo=${medFundNo}`)
      .then((res) => res.json())
      .then(
        (result) => {
          setLimitList(result.result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getLimitsPharmacy = (clientRefId) => {
    fetch(`${baseUrl}/api/product/GetLimitPharmacySummary?clientRefId=${clientRefId}`)
      .then((res) => res.json())
      .then(
        (result) => {
          setLimitListPharmacy(result.result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const populateDocumentsData = async (claimNo) => {
    const response = await fetch(`${baseUrl}/api/client/getdocumentsbyclient?claimId=${claimNo}`);
    const data = await response.json();
    if (data.result.length > 0) {
      setClientDocList(data.result);
    }
  };

  const populateDocumentsIdNumber = async (idNumber) => {
    const response = await fetch(`${baseUrl}/api/client/getDocumentsById?idNumber=${idNumber}`);
    const data = await response.json();
    if (data.result.length > 0) {
      setClientDocList(data.result);
    }
  };

  const updateGlBalances = async (accountRefId) => {
    const response = await fetch(
      `${baseUrl}/api/accounting/updateGlBalances?accountRefId=${accountRefId}&accountType=1`,
      {
        method: 'post',
        headers: { 'Content-Type': 'application/json' }
      }
    );
    const data = await response.json();
    console.log('updateGlBalances', data);
  };

  const getDependantsList = async (cifnos) => {
    console.log('clientrefid cifnos', cifnos);
    await axios(
      `${baseUrl}/api/client/GetDependantsByAfcCifNo?afcNumber=${cifnos}&includeMain=false`
    ).then(
      (res) => {
        console.log('depananan', res);
        setDependantList(res.data.result);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const getDocumentByRefId = async (refId) => {
    console.log('regRefId refId', refId);
    await fetch(`${baseUrl}/api/client/getDocumentByRefId?refId=${refId}`)
      .then((res) => res.json())
      .then(
        (result) => {
          setCurrentDoc(result.result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getClientPortfolio = () => {
    axios(
      `${loansUrl}/api/Client/GetClientLoanPortfolio?ecNumber=${currentClient.memberShipNo}`
    ).then(
      (res) => {
        console.log('res portfolio', res);
        // if (res.data.loanList === undefined || res.data.loanList === null) {
        //   console.log('no data returned');
        //   setPortfolio(initialLoanApp);
        // } else {
        //   setPortfolio(res.data);
        // }
        setPortfolio(res.data);
      },
      (error) => {
        alert(`failed here ${{ error }}`);
      }
    );
  };

  return (
    <ClientContext.Provider
      value={{
        ...state,
        searchClient,
        clientRefId,
        setClientRefId,
        currentClient,
        setCurrentClient,
        newClient,
        currDependant,
        setDependant,
        loadingClient,
        setLoadingClient,
        clientDocList,
        setClientDocList,
        refreshClientValues,
        clearContext,
        customerIdentifier,
        setCustomerIdentifier,
        limitsList,
        getLimits,
        getLimitsPharmacy,
        limitsListPharmacy,
        dependantList,
        setDependantList,
        parentRefId,
        setParentRefId,
        populateDocumentsData,
        regRefId,
        setRegRefId,
        populateDocumentsIdNumber,
        setNewClient,
        getClientByRefId,
        currentDocument,
        getDocumentByRefId,
        getClientsByAfc,
        loanPortfolio,
        getClientPortfolio,
        clearDependant,
        getDependantsList
      }}
    >
      {children}
    </ClientContext.Provider>
  );
};

export const useClientContext = () => useContext(ClientContext);
